import * as React from "react";

import { styled, Accordion, AccordionProps } from "@mui/material";
const SmallAccordion: React.FC<AccordionProps> = (props) => {
  return <StyledAccordion {...props} />;
};

export default SmallAccordion;

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  padding: 0,
  ".MuiAccordionSummary-root": {
    minHeight: 48,
    "&.Mui-expanded": {
      minHeight: 48,
    },
  },
  ".MuiAccordionSummary-content": {
    margin: `${theme.spacing(1)} 0`,
    justifyContent: "space-between",
  },
  ".MuiAccordionDetails-root": {
    paddingTop: theme.spacing(1.5),
  },
}));
